const initialState = {
	list: [],
	text: '',
	page: 1,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'MEMO_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.text = action.payload.text;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'MEMO_LIST_DATETIME_INIT') {
		let newState = Object.assign({}, state);
		newState.datetime = null;
		return newState;
	}
	else if (action.type === 'MEMO_ITEM_SET') {
		let newState = Object.assign({}, state);

		let index = state.list.findIndex((value) => {
			return value.userdata_id_code === action.payload.pic
		});

		if (index >= 0) {
			if (action.payload.type === 'edit') {
				newState.list[index]['comment'] = action.payload.text;
			}
			else if (action.payload.type === 'del') {
				newState.list.splice( index, 1 );
			}
		}

		return newState;
	}

	else {
		return state;
	}
}
